"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapeSwatch = void 0;
var shape_swatch_1 = require("./shape-swatch");
Object.defineProperty(exports, "ShapeSwatch", { enumerable: true, get: function () { return shape_swatch_1.ShapeSwatch; } });
